export const DFS_CONSTANTS = {
    NO_EVENT_MESSAGE:`No events are scheduled by National Electricity System Operator at the moment. 
                        We will send you an email when the event is scheduled. Keep an eye out for the mails from us!`
};